import { PartState } from '../types';
import { curiousState } from './curious';

/**
 * Looking right state — Bizy with eyes, badge, and stinger shifted
 * to face the right side. Wings are asymmetric with the left wings
 * spread wider (visible from the right-facing perspective).
 */
export const lookingRightState: PartState = {
	antenna1: curiousState.antenna1,
	antenna2: curiousState.antenna2,
	body: curiousState.body,
	bodyHighlight: curiousState.bodyHighlight,
	stripes: curiousState.stripes,
	eyes: {
		leftPath:
			'M142 100.5C142 97.462 144.462 95 147.5 95C150.538 95 153 97.462 153 100.5C153 100.5 153 107.5 153 107.5C153 110.538 150.538 113 148 113C147.5 113 147.5 113 147 113C144.462 113 142 110.538 142 107.5C142 107.5 142 100.5 142 100.5Z',
		rightPath:
			'M181 100.5C181 97.462 183.462 95 186.5 95C189.538 95 192 97.462 192 100.5C192 100.5 192 107.5 192 107.5C192 110.538 189.538 113 187 113C186.5 113 186.5 113 186 113C183.462 113 181 110.538 181 107.5C181 107.5 181 100.5 181 100.5Z',
	},
	wing1Path:
		'M213.384 133.332C193.494 155.592 144.414 152.032 125.544 150.502C124.084 150.332 123.304 148.542 124.144 147.302C147.944 112.112 193.974 86.1418 217.884 75.2118C242.624 63.9918 230.834 115.712 213.384 133.332Z',
	wing2Path:
		'M217.344 157.892C196.114 174.552 147.344 150.982 130.754 142.192C129.434 141.532 129.304 139.592 130.514 138.702C160.144 112.072 214.044 104.932 237.454 102.202C261.624 99.4525 237.444 149.242 217.344 157.892Z',
	wing3Path:
		'M91.2238 130.332C116.114 155.592 173.194 152.032 196.064 150.502C197.524 150.332 198.304 148.542 197.464 147.302C169.664 110.112 110.634 82.1423 80.7238 70.2123C49.9838 57.9923 67.7738 112.712 91.2238 130.332Z',
	wing4Path:
		'M86.2639 155.892C113.494 175.552 170.264 150.982 190.854 141.192C192.174 140.532 192.304 138.592 191.094 137.702C153.464 110.072 90.5639 100.932 58.1539 98.2023C24.9839 95.4523 61.1639 147.242 86.2639 155.892Z',
	arms: curiousState.arms,
	armOrder: 'leftFront',
	antennaOrder: 'leftFront',
	stinger:
		'M111.117 231.41C114.587 221.45 125.937 228.41 121.107 236.06C116.957 242.62 108.667 248.33 102.287 248.75C101.047 248.83 100.677 247.39 101.627 246.59C107.167 241.92 107.947 240.28 111.117 231.41Z',
	badge: {
		outerEllipse: { cx: 195, cy: 143.76, rx: 14.1, ry: 10.86 },
		innerEllipse: { cx: 195, cy: 143.76, rx: 12.19, ry: 9.34 },
		starPath:
			'M195 130.58C195.75 130.58 196.4 131.09 196.6 131.82L198.55 139.24L204.09 142.47C204.6 142.77 204.91 143.32 204.91 143.91C204.91 144.51 204.6 145.06 204.09 145.36L198.55 148.59L196.6 156.01C196.4 156.74 195.75 157.25 195 157.25C194.25 157.25 193.6 156.74 193.4 156.01L191.45 148.59L185.91 145.36C185.4 145.06 185.09 144.51 185.09 143.91C185.09 143.32 185.4 142.77 185.91 142.47L191.45 139.24L193.4 131.82C193.6 131.09 194.25 130.58 195 130.58Z',
		starHighlightPath:
			'M196.6 131.82C196.4 131.09 195.75 130.58 195 130.58C194.25 130.58 193.6 131.09 193.4 131.82L191.45 139.24L185.91 142.47L193.98 144.88C194.65 145.08 195.35 145.08 196.02 144.88L204.09 142.47L198.55 139.24L196.6 131.82Z',
	},
};
